import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const CustomerSupportAiAgentPage = () => (
  <SearchLandingPage config={searchLandingPages.customerSupportAiAgent} />
);

export default CustomerSupportAiAgentPage;
